import { Box } from '@mui/material';

import {
  BAIDU_ERROR_BOX_STYLES,
  BAIDU_ERROR_CODE_BOX_STYLES,
} from '../styles/universal-location-map.styles';

export interface MapBaiduErrorProps {
  height: string | number;
}

export function MapBaiduError({ height }: MapBaiduErrorProps) {
  const boxStyles = { ...BAIDU_ERROR_BOX_STYLES, height };

  return (
    <Box sx={boxStyles}>
      <Box sx={{ fontSize: '48px', mb: 2 }}>🗺️⚠️</Box>
      <Box sx={{ fontWeight: 'bold', mb: 1, fontSize: '18px' }}>Baidu Maps API Key Missing</Box>
      <Box sx={{ fontSize: '14px', color: 'text.secondary', mb: 2 }}>
        Baidu Maps is configured but no API key was found.
      </Box>
      <Box sx={BAIDU_ERROR_CODE_BOX_STYLES}>
        <div>Add to .env.local:</div>
        <div style={{ marginTop: '8px' }}>NEXT_PUBLIC_BAIDU_MAPS_API_KEY=your_actual_api_key</div>
        <div style={{ marginTop: '8px', fontSize: '11px', color: 'var(--palette-text-secondary, #666)' }}>
          Get your API key from: https://lbsyun.baidu.com/
        </div>
      </Box>
    </Box>
  );
}
